import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import InvoiceForm from './forms/InvoiceForm';
import InvoicesTable from './table/InvoiceTable';
import { setQueryString, useQueryString } from '../../common/helpers/queryString';
import { searchInvoices } from '../SettingsActions';
import RouterPaths from '../../constants/RouterPaths';

function InvoicesPage() {
  const query = useQueryString();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const items = useSelector((state) => state.myOrganization.get('invoices'));
  const totalItems = useSelector((state) => state.myOrganization.get('invoicesTotalItems'));
  const isOwner = useSelector((state) => state.auth.get('isOwner'));
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    if (!isOwner) {
      setHasAccess(false);
      return navigate(RouterPaths.DASHBOARD);
    }
    return setHasAccess(true);
  }, [isOwner, navigate]);

  const [searchParams, setSearchParams] = useState({
    offset: query.get('page') ? +query.get('page') - 1 : 0,
    location: { value: null },
  });

  useEffect(() => {
    dispatch(searchInvoices(searchParams));
  }, [dispatch, searchParams]);

  const changeOffset = (value) => {
    setSearchParams((prevState) => ({ ...prevState, offset: value }));
    navigate(setQueryString(location, 'page', value + 1));
  };

  const handleSearch = (values, { setSubmitting }) => {
    setSearchParams((prevState) => ({ ...prevState, ...values, offset: 0 }));
    setSubmitting(false);
  };

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {hasAccess && (
        <>
          <Row className="d-flex justify-content-between align-items-center mb-3 mt-4">
            <Col md={12}>
              <InvoiceForm handleSearch={handleSearch} />
            </Col>
          </Row>
          <Row>
            <InvoicesTable
              data={{ items, total: totalItems }}
              offset={searchParams.offset}
              changeOffset={changeOffset}
            />
          </Row>
        </>
      )}
    </>
  );
}

export default InvoicesPage;
